import { useCallback, useEffect, useRef, useState } from 'react';
import { copyText } from '../utils/clipboard';

// État « Copié » pendant `duration` ms après une copie réussie
export function useCopy(duration = 1500) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const copy = useCallback(async (text) => {
    const ok = await copyText(text);
    if (ok) {
      setCopied(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), duration);
    }
    return ok;
  }, [duration]);

  return { copied, copy };
}
